import donePage from './done-page.md';
import earlyDevelopmentPreamble from './early-development-preamble.md';
import faq from './faq.md';
import homepage from './homepage.md';
import largeSitePreamble from './large-site-preamble.md';
import legalObligationAccordion from './legal-obligation-accordion.md';
import reviewLegal from './review-legal.md';
import reviewPreamble from './review-preamble.md';
import signpostContent from './signpost-content.md';
import siteOperatorPreamble from './site-operator-preamble.md';
import smallSitePreamble from './small-site-preamble.md';
import stateCriticalPreamble from './state-critical-preamble.md';
import whatYouNeed from './what-you-need.md';
import yourRecordsPreamble from './your-records-preamble.md';
import yourWorkSitePreamble from './your-worksite-preamble.md';

export default {
  faq,
  homepage,
  whatYouNeed,
  siteOperatorPreamble,
  yourWorkSitePreamble,
  yourRecordsPreamble,
  reviewPreamble,
  reviewLegal,
  donePage,
  legalObligationAccordion,
  signpostContent,
  smallSitePreamble,
  largeSitePreamble,
  stateCriticalPreamble,
  earlyDevelopmentPreamble
} as {
  [key: string]: string;
};
